import { render, staticRenderFns } from "./AdminApunteDetalle.vue?vue&type=template&id=65c6d2f6&"
import script from "./AdminApunteDetalle.vue?vue&type=script&lang=js&"
export * from "./AdminApunteDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports